// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-272ba380]:export {\n  sideBarWidth: 210px;\n  appHeaderHeight: 60px;\n  interval: 16px;\n}\n.honour-card[data-v-272ba380] {\n  width: 320px;\n}\n.honour-card img[data-v-272ba380] {\n  width: 100%;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
